import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor() { }

  public onAlert: EventEmitter<any> = new EventEmitter();
  public onAlertHide: EventEmitter<any> = new EventEmitter();
}
